<script setup>
const props = defineProps({
    contentBoxHeadlineConfig: {
        type: Object,
        default: () => ({}),
        validator: (rawValue) => {
            const validations = {
                title: value => value?.headline?.title === undefined || typeof value.headline?.title === 'string',
                type: value => value?.headline?.type === undefined || typeof value.headline?.type === 'string',
                iconName: value => value?.icon?.name === undefined || typeof value.icon?.name === 'string' || typeof value.icon?.name === 'object',
                iconSize: value => value?.icon?.size === undefined || (typeof value.icon?.size === 'string' && ['large'].includes(value.icon?.size)),
                alignment: value => value?.alignment === undefined || typeof value.alignment === 'string',
                placeholder: value => value?.placeholder === undefined || typeof value.placeholder === 'boolean'
            }

            return Object.entries(validations).every(([_, validation]) => validation(rawValue))
        }
    }
})

// Determine headline type or default to 'h3'
const headlineType = computed(() => props.contentBoxHeadlineConfig?.headline?.type || 'h3')

// Check if icon size is large
const isLargeIcon = computed(() => props.contentBoxHeadlineConfig?.icon?.size === 'large')
</script>

<template>
    <component
        :is="'SkeletonPlaceholder'"
        v-if="contentBoxHeadlineConfig.placeholder"
        :skeleton-placeholder-config="{ type: 'multi-headline', tag: 'h3' }"
    />

    <component
        :is="headlineType"
        v-else-if="contentBoxHeadlineConfig.headline?.title"
        class="content-box-headline"
        :data-align="contentBoxHeadlineConfig?.alignment"
    >
        <IconWrap v-if="isLargeIcon">
            <component :is="contentBoxHeadlineConfig?.icon?.name" />
        </IconWrap>

        <component :is="contentBoxHeadlineConfig?.icon?.name" v-else />

        {{ contentBoxHeadlineConfig?.headline?.title }}
    </component>
</template>

<style lang="scss">
.content-box-headline {
    font-size: px2rem(20);
    line-height: px2rem(25);
    display: flex;
    align-items: center;
    font-family: $font-body;
    font-weight: 600;
    margin: 0 0 20px;

    @include bp(medium1) {
        font-size: px2rem(20);
        line-height: px2rem(25);
        margin: 0 0 30px;
    }

    > svg {
        width: 100%;
        height: 100%;
        max-height: 20px;
        max-width: 20px;
        margin-inline-end: 10px;

        @include bp(large2) {
            max-height: 25px;
            max-width: 25px;
            margin-inline-end: 15px;
        }
    }

    &[data-align='top'] {
        align-items: flex-start;

        > svg {
            margin-block-start: px2rem(4);
        }
    }
}
</style>
